import { render, staticRenderFns } from "./permissionEdit.vue?vue&type=template&id=aef8f7ac&scoped=true&"
import script from "./permissionEdit.vue?vue&type=script&lang=ts&"
export * from "./permissionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./permissionEdit.vue?vue&type=style&index=0&id=aef8f7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef8f7ac",
  null
  
)

export default component.exports